import useApi, { UseApiFetch } from 'hooks/useApi';

type ApiAuth = {
    userId: string;
    jwtToken: string;
    userType: 'user' | 'admin';
    language: string;
};

type ApiAuthResponseData = {
    apiAuth: ApiAuth;
};

type UseApiLogin = {
    loading: boolean;
    login: UseApiFetch<ApiAuthResponseData>;
};

export default function useApiLogin(): UseApiLogin {
    const { loading, doFetch } = useApi<ApiAuthResponseData>({
        slug: 'partnermarketing_authentication_user_login_api',
        method: 'POST',
        // no autofetch
        lazy: true,
    });

    return {
        loading,
        login: doFetch,
    };
}
